/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as AuthedIndexRouteImport } from './routes/_authed/index'
import { Route as AuthedOpsRouteRouteImport } from './routes/_authed/ops/route'
import { Route as AuthedOpsIndexRouteImport } from './routes/_authed/ops/index'
import { Route as AuthedOpsInboxRouteImport } from './routes/_authed/ops/inbox'
import { Route as AuthedOrgIndexRouteImport } from './routes/_authed/org/index'
import { Route as AuthedOrgOrganizationIdRouteRouteImport } from './routes/_authed/org/$organizationId/route'
import { Route as AuthedOrgNewRouteImport } from './routes/_authed/org/new'
import { Route as AuthedOpsAuditIndexRouteImport } from './routes/_authed/ops/audit/index'
import { Route as AuthedOpsCandidatesIndexRouteImport } from './routes/_authed/ops/candidates/index'
import { Route as AuthedOpsCandidatesCandidateIdRouteImport } from './routes/_authed/ops/candidates/$candidateId'
import { Route as AuthedOpsDuplicatesIndexRouteImport } from './routes/_authed/ops/duplicates/index'
import { Route as AuthedOpsDuplicatesGroupIdRouteImport } from './routes/_authed/ops/duplicates/$groupId'
import { Route as AuthedOpsEventsIndexRouteImport } from './routes/_authed/ops/events/index'
import { Route as AuthedOpsOrganizationsIndexRouteImport } from './routes/_authed/ops/organizations/index'
import { Route as AuthedOpsQualityIndexRouteImport } from './routes/_authed/ops/quality/index'
import { Route as AuthedOpsRulesIndexRouteImport } from './routes/_authed/ops/rules/index'
import { Route as AuthedOpsRulesRuleIdRouteImport } from './routes/_authed/ops/rules/$ruleId'
import { Route as AuthedOpsRulesNewRouteImport } from './routes/_authed/ops/rules/new'
import { Route as AuthedOpsRunsIndexRouteImport } from './routes/_authed/ops/runs/index'
import { Route as AuthedOpsRunsRunIdRouteImport } from './routes/_authed/ops/runs/$runId'
import { Route as AuthedOpsSourcesIndexRouteImport } from './routes/_authed/ops/sources/index'
import { Route as AuthedOpsSourcesSourceIdRouteImport } from './routes/_authed/ops/sources/$sourceId'
import { Route as AuthedOpsSponsoredIndexRouteImport } from './routes/_authed/ops/sponsored/index'
import { Route as AuthedOpsSponsoredIdRouteImport } from './routes/_authed/ops/sponsored/$id'
import { Route as AuthedOpsSponsoredNewRouteImport } from './routes/_authed/ops/sponsored/new'
import { Route as AuthedOpsSurveysIndexRouteImport } from './routes/_authed/ops/surveys/index'
import { Route as AuthedOpsSurveysSurveyIdRouteImport } from './routes/_authed/ops/surveys/$surveyId'
import { Route as AuthedOpsSurveysNewRouteImport } from './routes/_authed/ops/surveys/new'
import { Route as AuthedOpsTransferIndexRouteImport } from './routes/_authed/ops/transfer/index'
import { Route as AuthedOrgOrganizationIdIndexRouteImport } from './routes/_authed/org/$organizationId/index'
import { Route as AuthedOrgOrganizationIdMembersRouteImport } from './routes/_authed/org/$organizationId/members'
import { Route as AuthedOrgOrganizationIdSettingsRouteImport } from './routes/_authed/org/$organizationId/settings'
import { Route as AuthedOrgOrganizationIdEventsIndexRouteImport } from './routes/_authed/org/$organizationId/events/index'
import { Route as AuthedOrgOrganizationIdEventsNewRouteImport } from './routes/_authed/org/$organizationId/events/new'
import { Route as AuthedOrgOrganizationIdEventsEventIdIndexRouteImport } from './routes/_authed/org/$organizationId/events/$eventId/index'
import { Route as AuthedOrgOrganizationIdEventsEventIdEditRouteImport } from './routes/_authed/org/$organizationId/events/$eventId/edit'
import { Route as AuthedOrgOrganizationIdEventsEventIdRunnersRouteImport } from './routes/_authed/org/$organizationId/events/$eventId/runners'

const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const SignUpRoute = SignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedIndexRoute = AuthedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedOpsRouteRoute = AuthedOpsRouteRouteImport.update({
  id: '/ops',
  path: '/ops',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedOpsIndexRoute = AuthedOpsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedOpsRouteRoute,
} as any)
const AuthedOpsInboxRoute = AuthedOpsInboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => AuthedOpsRouteRoute,
} as any)
const AuthedOrgIndexRoute = AuthedOrgIndexRouteImport.update({
  id: '/org/',
  path: '/org/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedOrgOrganizationIdRouteRoute =
  AuthedOrgOrganizationIdRouteRouteImport.update({
    id: '/org/$organizationId',
    path: '/org/$organizationId',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedOrgNewRoute = AuthedOrgNewRouteImport.update({
  id: '/org/new',
  path: '/org/new',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedOpsAuditIndexRoute = AuthedOpsAuditIndexRouteImport.update({
  id: '/audit/',
  path: '/audit/',
  getParentRoute: () => AuthedOpsRouteRoute,
} as any)
const AuthedOpsCandidatesIndexRoute =
  AuthedOpsCandidatesIndexRouteImport.update({
    id: '/candidates/',
    path: '/candidates/',
    getParentRoute: () => AuthedOpsRouteRoute,
  } as any)
const AuthedOpsCandidatesCandidateIdRoute =
  AuthedOpsCandidatesCandidateIdRouteImport.update({
    id: '/candidates/$candidateId',
    path: '/candidates/$candidateId',
    getParentRoute: () => AuthedOpsRouteRoute,
  } as any)
const AuthedOpsDuplicatesIndexRoute =
  AuthedOpsDuplicatesIndexRouteImport.update({
    id: '/duplicates/',
    path: '/duplicates/',
    getParentRoute: () => AuthedOpsRouteRoute,
  } as any)
const AuthedOpsDuplicatesGroupIdRoute =
  AuthedOpsDuplicatesGroupIdRouteImport.update({
    id: '/duplicates/$groupId',
    path: '/duplicates/$groupId',
    getParentRoute: () => AuthedOpsRouteRoute,
  } as any)
const AuthedOpsEventsIndexRoute = AuthedOpsEventsIndexRouteImport.update({
  id: '/events/',
  path: '/events/',
  getParentRoute: () => AuthedOpsRouteRoute,
} as any)
const AuthedOpsOrganizationsIndexRoute =
  AuthedOpsOrganizationsIndexRouteImport.update({
    id: '/organizations/',
    path: '/organizations/',
    getParentRoute: () => AuthedOpsRouteRoute,
  } as any)
const AuthedOpsQualityIndexRoute = AuthedOpsQualityIndexRouteImport.update({
  id: '/quality/',
  path: '/quality/',
  getParentRoute: () => AuthedOpsRouteRoute,
} as any)
const AuthedOpsRulesIndexRoute = AuthedOpsRulesIndexRouteImport.update({
  id: '/rules/',
  path: '/rules/',
  getParentRoute: () => AuthedOpsRouteRoute,
} as any)
const AuthedOpsRulesRuleIdRoute = AuthedOpsRulesRuleIdRouteImport.update({
  id: '/rules/$ruleId',
  path: '/rules/$ruleId',
  getParentRoute: () => AuthedOpsRouteRoute,
} as any)
const AuthedOpsRulesNewRoute = AuthedOpsRulesNewRouteImport.update({
  id: '/rules/new',
  path: '/rules/new',
  getParentRoute: () => AuthedOpsRouteRoute,
} as any)
const AuthedOpsRunsIndexRoute = AuthedOpsRunsIndexRouteImport.update({
  id: '/runs/',
  path: '/runs/',
  getParentRoute: () => AuthedOpsRouteRoute,
} as any)
const AuthedOpsRunsRunIdRoute = AuthedOpsRunsRunIdRouteImport.update({
  id: '/runs/$runId',
  path: '/runs/$runId',
  getParentRoute: () => AuthedOpsRouteRoute,
} as any)
const AuthedOpsSourcesIndexRoute = AuthedOpsSourcesIndexRouteImport.update({
  id: '/sources/',
  path: '/sources/',
  getParentRoute: () => AuthedOpsRouteRoute,
} as any)
const AuthedOpsSourcesSourceIdRoute =
  AuthedOpsSourcesSourceIdRouteImport.update({
    id: '/sources/$sourceId',
    path: '/sources/$sourceId',
    getParentRoute: () => AuthedOpsRouteRoute,
  } as any)
const AuthedOpsSponsoredIndexRoute = AuthedOpsSponsoredIndexRouteImport.update({
  id: '/sponsored/',
  path: '/sponsored/',
  getParentRoute: () => AuthedOpsRouteRoute,
} as any)
const AuthedOpsSponsoredIdRoute = AuthedOpsSponsoredIdRouteImport.update({
  id: '/sponsored/$id',
  path: '/sponsored/$id',
  getParentRoute: () => AuthedOpsRouteRoute,
} as any)
const AuthedOpsSponsoredNewRoute = AuthedOpsSponsoredNewRouteImport.update({
  id: '/sponsored/new',
  path: '/sponsored/new',
  getParentRoute: () => AuthedOpsRouteRoute,
} as any)
const AuthedOpsSurveysIndexRoute = AuthedOpsSurveysIndexRouteImport.update({
  id: '/surveys/',
  path: '/surveys/',
  getParentRoute: () => AuthedOpsRouteRoute,
} as any)
const AuthedOpsSurveysSurveyIdRoute =
  AuthedOpsSurveysSurveyIdRouteImport.update({
    id: '/surveys/$surveyId',
    path: '/surveys/$surveyId',
    getParentRoute: () => AuthedOpsRouteRoute,
  } as any)
const AuthedOpsSurveysNewRoute = AuthedOpsSurveysNewRouteImport.update({
  id: '/surveys/new',
  path: '/surveys/new',
  getParentRoute: () => AuthedOpsRouteRoute,
} as any)
const AuthedOpsTransferIndexRoute = AuthedOpsTransferIndexRouteImport.update({
  id: '/transfer/',
  path: '/transfer/',
  getParentRoute: () => AuthedOpsRouteRoute,
} as any)
const AuthedOrgOrganizationIdIndexRoute =
  AuthedOrgOrganizationIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthedOrgOrganizationIdRouteRoute,
  } as any)
const AuthedOrgOrganizationIdMembersRoute =
  AuthedOrgOrganizationIdMembersRouteImport.update({
    id: '/members',
    path: '/members',
    getParentRoute: () => AuthedOrgOrganizationIdRouteRoute,
  } as any)
const AuthedOrgOrganizationIdSettingsRoute =
  AuthedOrgOrganizationIdSettingsRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthedOrgOrganizationIdRouteRoute,
  } as any)
const AuthedOrgOrganizationIdEventsIndexRoute =
  AuthedOrgOrganizationIdEventsIndexRouteImport.update({
    id: '/events/',
    path: '/events/',
    getParentRoute: () => AuthedOrgOrganizationIdRouteRoute,
  } as any)
const AuthedOrgOrganizationIdEventsNewRoute =
  AuthedOrgOrganizationIdEventsNewRouteImport.update({
    id: '/events/new',
    path: '/events/new',
    getParentRoute: () => AuthedOrgOrganizationIdRouteRoute,
  } as any)
const AuthedOrgOrganizationIdEventsEventIdIndexRoute =
  AuthedOrgOrganizationIdEventsEventIdIndexRouteImport.update({
    id: '/events/$eventId/',
    path: '/events/$eventId/',
    getParentRoute: () => AuthedOrgOrganizationIdRouteRoute,
  } as any)
const AuthedOrgOrganizationIdEventsEventIdEditRoute =
  AuthedOrgOrganizationIdEventsEventIdEditRouteImport.update({
    id: '/events/$eventId/edit',
    path: '/events/$eventId/edit',
    getParentRoute: () => AuthedOrgOrganizationIdRouteRoute,
  } as any)
const AuthedOrgOrganizationIdEventsEventIdRunnersRoute =
  AuthedOrgOrganizationIdEventsEventIdRunnersRouteImport.update({
    id: '/events/$eventId/runners',
    path: '/events/$eventId/runners',
    getParentRoute: () => AuthedOrgOrganizationIdRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthedIndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-up': typeof SignUpRoute
  '/verify-email': typeof VerifyEmailRoute
  '/ops': typeof AuthedOpsRouteRouteWithChildren
  '/org/$organizationId': typeof AuthedOrgOrganizationIdRouteRouteWithChildren
  '/ops/inbox': typeof AuthedOpsInboxRoute
  '/org/new': typeof AuthedOrgNewRoute
  '/ops/': typeof AuthedOpsIndexRoute
  '/org/': typeof AuthedOrgIndexRoute
  '/ops/candidates/$candidateId': typeof AuthedOpsCandidatesCandidateIdRoute
  '/ops/duplicates/$groupId': typeof AuthedOpsDuplicatesGroupIdRoute
  '/ops/rules/$ruleId': typeof AuthedOpsRulesRuleIdRoute
  '/ops/rules/new': typeof AuthedOpsRulesNewRoute
  '/ops/runs/$runId': typeof AuthedOpsRunsRunIdRoute
  '/ops/sources/$sourceId': typeof AuthedOpsSourcesSourceIdRoute
  '/ops/sponsored/$id': typeof AuthedOpsSponsoredIdRoute
  '/ops/sponsored/new': typeof AuthedOpsSponsoredNewRoute
  '/ops/surveys/$surveyId': typeof AuthedOpsSurveysSurveyIdRoute
  '/ops/surveys/new': typeof AuthedOpsSurveysNewRoute
  '/org/$organizationId/members': typeof AuthedOrgOrganizationIdMembersRoute
  '/org/$organizationId/settings': typeof AuthedOrgOrganizationIdSettingsRoute
  '/ops/audit/': typeof AuthedOpsAuditIndexRoute
  '/ops/candidates/': typeof AuthedOpsCandidatesIndexRoute
  '/ops/duplicates/': typeof AuthedOpsDuplicatesIndexRoute
  '/ops/events/': typeof AuthedOpsEventsIndexRoute
  '/ops/organizations/': typeof AuthedOpsOrganizationsIndexRoute
  '/ops/quality/': typeof AuthedOpsQualityIndexRoute
  '/ops/rules/': typeof AuthedOpsRulesIndexRoute
  '/ops/runs/': typeof AuthedOpsRunsIndexRoute
  '/ops/sources/': typeof AuthedOpsSourcesIndexRoute
  '/ops/sponsored/': typeof AuthedOpsSponsoredIndexRoute
  '/ops/surveys/': typeof AuthedOpsSurveysIndexRoute
  '/ops/transfer/': typeof AuthedOpsTransferIndexRoute
  '/org/$organizationId/': typeof AuthedOrgOrganizationIdIndexRoute
  '/org/$organizationId/events/new': typeof AuthedOrgOrganizationIdEventsNewRoute
  '/org/$organizationId/events/': typeof AuthedOrgOrganizationIdEventsIndexRoute
  '/org/$organizationId/events/$eventId/edit': typeof AuthedOrgOrganizationIdEventsEventIdEditRoute
  '/org/$organizationId/events/$eventId/runners': typeof AuthedOrgOrganizationIdEventsEventIdRunnersRoute
  '/org/$organizationId/events/$eventId/': typeof AuthedOrgOrganizationIdEventsEventIdIndexRoute
}
export interface FileRoutesByTo {
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-up': typeof SignUpRoute
  '/verify-email': typeof VerifyEmailRoute
  '/': typeof AuthedIndexRoute
  '/ops/inbox': typeof AuthedOpsInboxRoute
  '/org/new': typeof AuthedOrgNewRoute
  '/ops': typeof AuthedOpsIndexRoute
  '/org': typeof AuthedOrgIndexRoute
  '/ops/candidates/$candidateId': typeof AuthedOpsCandidatesCandidateIdRoute
  '/ops/duplicates/$groupId': typeof AuthedOpsDuplicatesGroupIdRoute
  '/ops/rules/$ruleId': typeof AuthedOpsRulesRuleIdRoute
  '/ops/rules/new': typeof AuthedOpsRulesNewRoute
  '/ops/runs/$runId': typeof AuthedOpsRunsRunIdRoute
  '/ops/sources/$sourceId': typeof AuthedOpsSourcesSourceIdRoute
  '/ops/sponsored/$id': typeof AuthedOpsSponsoredIdRoute
  '/ops/sponsored/new': typeof AuthedOpsSponsoredNewRoute
  '/ops/surveys/$surveyId': typeof AuthedOpsSurveysSurveyIdRoute
  '/ops/surveys/new': typeof AuthedOpsSurveysNewRoute
  '/org/$organizationId/members': typeof AuthedOrgOrganizationIdMembersRoute
  '/org/$organizationId/settings': typeof AuthedOrgOrganizationIdSettingsRoute
  '/ops/audit': typeof AuthedOpsAuditIndexRoute
  '/ops/candidates': typeof AuthedOpsCandidatesIndexRoute
  '/ops/duplicates': typeof AuthedOpsDuplicatesIndexRoute
  '/ops/events': typeof AuthedOpsEventsIndexRoute
  '/ops/organizations': typeof AuthedOpsOrganizationsIndexRoute
  '/ops/quality': typeof AuthedOpsQualityIndexRoute
  '/ops/rules': typeof AuthedOpsRulesIndexRoute
  '/ops/runs': typeof AuthedOpsRunsIndexRoute
  '/ops/sources': typeof AuthedOpsSourcesIndexRoute
  '/ops/sponsored': typeof AuthedOpsSponsoredIndexRoute
  '/ops/surveys': typeof AuthedOpsSurveysIndexRoute
  '/ops/transfer': typeof AuthedOpsTransferIndexRoute
  '/org/$organizationId': typeof AuthedOrgOrganizationIdIndexRoute
  '/org/$organizationId/events/new': typeof AuthedOrgOrganizationIdEventsNewRoute
  '/org/$organizationId/events': typeof AuthedOrgOrganizationIdEventsIndexRoute
  '/org/$organizationId/events/$eventId/edit': typeof AuthedOrgOrganizationIdEventsEventIdEditRoute
  '/org/$organizationId/events/$eventId/runners': typeof AuthedOrgOrganizationIdEventsEventIdRunnersRoute
  '/org/$organizationId/events/$eventId': typeof AuthedOrgOrganizationIdEventsEventIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authed': typeof AuthedRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-up': typeof SignUpRoute
  '/verify-email': typeof VerifyEmailRoute
  '/_authed/ops': typeof AuthedOpsRouteRouteWithChildren
  '/_authed/': typeof AuthedIndexRoute
  '/_authed/org/$organizationId': typeof AuthedOrgOrganizationIdRouteRouteWithChildren
  '/_authed/ops/inbox': typeof AuthedOpsInboxRoute
  '/_authed/org/new': typeof AuthedOrgNewRoute
  '/_authed/ops/': typeof AuthedOpsIndexRoute
  '/_authed/org/': typeof AuthedOrgIndexRoute
  '/_authed/ops/candidates/$candidateId': typeof AuthedOpsCandidatesCandidateIdRoute
  '/_authed/ops/duplicates/$groupId': typeof AuthedOpsDuplicatesGroupIdRoute
  '/_authed/ops/rules/$ruleId': typeof AuthedOpsRulesRuleIdRoute
  '/_authed/ops/rules/new': typeof AuthedOpsRulesNewRoute
  '/_authed/ops/runs/$runId': typeof AuthedOpsRunsRunIdRoute
  '/_authed/ops/sources/$sourceId': typeof AuthedOpsSourcesSourceIdRoute
  '/_authed/ops/sponsored/$id': typeof AuthedOpsSponsoredIdRoute
  '/_authed/ops/sponsored/new': typeof AuthedOpsSponsoredNewRoute
  '/_authed/ops/surveys/$surveyId': typeof AuthedOpsSurveysSurveyIdRoute
  '/_authed/ops/surveys/new': typeof AuthedOpsSurveysNewRoute
  '/_authed/org/$organizationId/members': typeof AuthedOrgOrganizationIdMembersRoute
  '/_authed/org/$organizationId/settings': typeof AuthedOrgOrganizationIdSettingsRoute
  '/_authed/ops/audit/': typeof AuthedOpsAuditIndexRoute
  '/_authed/ops/candidates/': typeof AuthedOpsCandidatesIndexRoute
  '/_authed/ops/duplicates/': typeof AuthedOpsDuplicatesIndexRoute
  '/_authed/ops/events/': typeof AuthedOpsEventsIndexRoute
  '/_authed/ops/organizations/': typeof AuthedOpsOrganizationsIndexRoute
  '/_authed/ops/quality/': typeof AuthedOpsQualityIndexRoute
  '/_authed/ops/rules/': typeof AuthedOpsRulesIndexRoute
  '/_authed/ops/runs/': typeof AuthedOpsRunsIndexRoute
  '/_authed/ops/sources/': typeof AuthedOpsSourcesIndexRoute
  '/_authed/ops/sponsored/': typeof AuthedOpsSponsoredIndexRoute
  '/_authed/ops/surveys/': typeof AuthedOpsSurveysIndexRoute
  '/_authed/ops/transfer/': typeof AuthedOpsTransferIndexRoute
  '/_authed/org/$organizationId/': typeof AuthedOrgOrganizationIdIndexRoute
  '/_authed/org/$organizationId/events/new': typeof AuthedOrgOrganizationIdEventsNewRoute
  '/_authed/org/$organizationId/events/': typeof AuthedOrgOrganizationIdEventsIndexRoute
  '/_authed/org/$organizationId/events/$eventId/edit': typeof AuthedOrgOrganizationIdEventsEventIdEditRoute
  '/_authed/org/$organizationId/events/$eventId/runners': typeof AuthedOrgOrganizationIdEventsEventIdRunnersRoute
  '/_authed/org/$organizationId/events/$eventId/': typeof AuthedOrgOrganizationIdEventsEventIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/sign-up'
    | '/verify-email'
    | '/ops'
    | '/org/$organizationId'
    | '/ops/inbox'
    | '/org/new'
    | '/ops/'
    | '/org/'
    | '/ops/candidates/$candidateId'
    | '/ops/duplicates/$groupId'
    | '/ops/rules/$ruleId'
    | '/ops/rules/new'
    | '/ops/runs/$runId'
    | '/ops/sources/$sourceId'
    | '/ops/sponsored/$id'
    | '/ops/sponsored/new'
    | '/ops/surveys/$surveyId'
    | '/ops/surveys/new'
    | '/org/$organizationId/members'
    | '/org/$organizationId/settings'
    | '/ops/audit/'
    | '/ops/candidates/'
    | '/ops/duplicates/'
    | '/ops/events/'
    | '/ops/organizations/'
    | '/ops/quality/'
    | '/ops/rules/'
    | '/ops/runs/'
    | '/ops/sources/'
    | '/ops/sponsored/'
    | '/ops/surveys/'
    | '/ops/transfer/'
    | '/org/$organizationId/'
    | '/org/$organizationId/events/new'
    | '/org/$organizationId/events/'
    | '/org/$organizationId/events/$eventId/edit'
    | '/org/$organizationId/events/$eventId/runners'
    | '/org/$organizationId/events/$eventId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/sign-up'
    | '/verify-email'
    | '/'
    | '/ops/inbox'
    | '/org/new'
    | '/ops'
    | '/org'
    | '/ops/candidates/$candidateId'
    | '/ops/duplicates/$groupId'
    | '/ops/rules/$ruleId'
    | '/ops/rules/new'
    | '/ops/runs/$runId'
    | '/ops/sources/$sourceId'
    | '/ops/sponsored/$id'
    | '/ops/sponsored/new'
    | '/ops/surveys/$surveyId'
    | '/ops/surveys/new'
    | '/org/$organizationId/members'
    | '/org/$organizationId/settings'
    | '/ops/audit'
    | '/ops/candidates'
    | '/ops/duplicates'
    | '/ops/events'
    | '/ops/organizations'
    | '/ops/quality'
    | '/ops/rules'
    | '/ops/runs'
    | '/ops/sources'
    | '/ops/sponsored'
    | '/ops/surveys'
    | '/ops/transfer'
    | '/org/$organizationId'
    | '/org/$organizationId/events/new'
    | '/org/$organizationId/events'
    | '/org/$organizationId/events/$eventId/edit'
    | '/org/$organizationId/events/$eventId/runners'
    | '/org/$organizationId/events/$eventId'
  id:
    | '__root__'
    | '/_authed'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/sign-up'
    | '/verify-email'
    | '/_authed/ops'
    | '/_authed/'
    | '/_authed/org/$organizationId'
    | '/_authed/ops/inbox'
    | '/_authed/org/new'
    | '/_authed/ops/'
    | '/_authed/org/'
    | '/_authed/ops/candidates/$candidateId'
    | '/_authed/ops/duplicates/$groupId'
    | '/_authed/ops/rules/$ruleId'
    | '/_authed/ops/rules/new'
    | '/_authed/ops/runs/$runId'
    | '/_authed/ops/sources/$sourceId'
    | '/_authed/ops/sponsored/$id'
    | '/_authed/ops/sponsored/new'
    | '/_authed/ops/surveys/$surveyId'
    | '/_authed/ops/surveys/new'
    | '/_authed/org/$organizationId/members'
    | '/_authed/org/$organizationId/settings'
    | '/_authed/ops/audit/'
    | '/_authed/ops/candidates/'
    | '/_authed/ops/duplicates/'
    | '/_authed/ops/events/'
    | '/_authed/ops/organizations/'
    | '/_authed/ops/quality/'
    | '/_authed/ops/rules/'
    | '/_authed/ops/runs/'
    | '/_authed/ops/sources/'
    | '/_authed/ops/sponsored/'
    | '/_authed/ops/surveys/'
    | '/_authed/ops/transfer/'
    | '/_authed/org/$organizationId/'
    | '/_authed/org/$organizationId/events/new'
    | '/_authed/org/$organizationId/events/'
    | '/_authed/org/$organizationId/events/$eventId/edit'
    | '/_authed/org/$organizationId/events/$eventId/runners'
    | '/_authed/org/$organizationId/events/$eventId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthedRoute: typeof AuthedRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignUpRoute: typeof SignUpRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/': {
      id: '/_authed/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthedIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/ops': {
      id: '/_authed/ops'
      path: '/ops'
      fullPath: '/ops'
      preLoaderRoute: typeof AuthedOpsRouteRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/ops/': {
      id: '/_authed/ops/'
      path: '/'
      fullPath: '/ops/'
      preLoaderRoute: typeof AuthedOpsIndexRouteImport
      parentRoute: typeof AuthedOpsRouteRoute
    }
    '/_authed/ops/inbox': {
      id: '/_authed/ops/inbox'
      path: '/inbox'
      fullPath: '/ops/inbox'
      preLoaderRoute: typeof AuthedOpsInboxRouteImport
      parentRoute: typeof AuthedOpsRouteRoute
    }
    '/_authed/org/': {
      id: '/_authed/org/'
      path: '/org'
      fullPath: '/org/'
      preLoaderRoute: typeof AuthedOrgIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/org/$organizationId': {
      id: '/_authed/org/$organizationId'
      path: '/org/$organizationId'
      fullPath: '/org/$organizationId'
      preLoaderRoute: typeof AuthedOrgOrganizationIdRouteRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/org/new': {
      id: '/_authed/org/new'
      path: '/org/new'
      fullPath: '/org/new'
      preLoaderRoute: typeof AuthedOrgNewRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/ops/audit/': {
      id: '/_authed/ops/audit/'
      path: '/audit'
      fullPath: '/ops/audit/'
      preLoaderRoute: typeof AuthedOpsAuditIndexRouteImport
      parentRoute: typeof AuthedOpsRouteRoute
    }
    '/_authed/ops/candidates/': {
      id: '/_authed/ops/candidates/'
      path: '/candidates'
      fullPath: '/ops/candidates/'
      preLoaderRoute: typeof AuthedOpsCandidatesIndexRouteImport
      parentRoute: typeof AuthedOpsRouteRoute
    }
    '/_authed/ops/candidates/$candidateId': {
      id: '/_authed/ops/candidates/$candidateId'
      path: '/candidates/$candidateId'
      fullPath: '/ops/candidates/$candidateId'
      preLoaderRoute: typeof AuthedOpsCandidatesCandidateIdRouteImport
      parentRoute: typeof AuthedOpsRouteRoute
    }
    '/_authed/ops/duplicates/': {
      id: '/_authed/ops/duplicates/'
      path: '/duplicates'
      fullPath: '/ops/duplicates/'
      preLoaderRoute: typeof AuthedOpsDuplicatesIndexRouteImport
      parentRoute: typeof AuthedOpsRouteRoute
    }
    '/_authed/ops/duplicates/$groupId': {
      id: '/_authed/ops/duplicates/$groupId'
      path: '/duplicates/$groupId'
      fullPath: '/ops/duplicates/$groupId'
      preLoaderRoute: typeof AuthedOpsDuplicatesGroupIdRouteImport
      parentRoute: typeof AuthedOpsRouteRoute
    }
    '/_authed/ops/events/': {
      id: '/_authed/ops/events/'
      path: '/events'
      fullPath: '/ops/events/'
      preLoaderRoute: typeof AuthedOpsEventsIndexRouteImport
      parentRoute: typeof AuthedOpsRouteRoute
    }
    '/_authed/ops/organizations/': {
      id: '/_authed/ops/organizations/'
      path: '/organizations'
      fullPath: '/ops/organizations/'
      preLoaderRoute: typeof AuthedOpsOrganizationsIndexRouteImport
      parentRoute: typeof AuthedOpsRouteRoute
    }
    '/_authed/ops/quality/': {
      id: '/_authed/ops/quality/'
      path: '/quality'
      fullPath: '/ops/quality/'
      preLoaderRoute: typeof AuthedOpsQualityIndexRouteImport
      parentRoute: typeof AuthedOpsRouteRoute
    }
    '/_authed/ops/rules/': {
      id: '/_authed/ops/rules/'
      path: '/rules'
      fullPath: '/ops/rules/'
      preLoaderRoute: typeof AuthedOpsRulesIndexRouteImport
      parentRoute: typeof AuthedOpsRouteRoute
    }
    '/_authed/ops/rules/$ruleId': {
      id: '/_authed/ops/rules/$ruleId'
      path: '/rules/$ruleId'
      fullPath: '/ops/rules/$ruleId'
      preLoaderRoute: typeof AuthedOpsRulesRuleIdRouteImport
      parentRoute: typeof AuthedOpsRouteRoute
    }
    '/_authed/ops/rules/new': {
      id: '/_authed/ops/rules/new'
      path: '/rules/new'
      fullPath: '/ops/rules/new'
      preLoaderRoute: typeof AuthedOpsRulesNewRouteImport
      parentRoute: typeof AuthedOpsRouteRoute
    }
    '/_authed/ops/runs/': {
      id: '/_authed/ops/runs/'
      path: '/runs'
      fullPath: '/ops/runs/'
      preLoaderRoute: typeof AuthedOpsRunsIndexRouteImport
      parentRoute: typeof AuthedOpsRouteRoute
    }
    '/_authed/ops/runs/$runId': {
      id: '/_authed/ops/runs/$runId'
      path: '/runs/$runId'
      fullPath: '/ops/runs/$runId'
      preLoaderRoute: typeof AuthedOpsRunsRunIdRouteImport
      parentRoute: typeof AuthedOpsRouteRoute
    }
    '/_authed/ops/sources/': {
      id: '/_authed/ops/sources/'
      path: '/sources'
      fullPath: '/ops/sources/'
      preLoaderRoute: typeof AuthedOpsSourcesIndexRouteImport
      parentRoute: typeof AuthedOpsRouteRoute
    }
    '/_authed/ops/sources/$sourceId': {
      id: '/_authed/ops/sources/$sourceId'
      path: '/sources/$sourceId'
      fullPath: '/ops/sources/$sourceId'
      preLoaderRoute: typeof AuthedOpsSourcesSourceIdRouteImport
      parentRoute: typeof AuthedOpsRouteRoute
    }
    '/_authed/ops/sponsored/': {
      id: '/_authed/ops/sponsored/'
      path: '/sponsored'
      fullPath: '/ops/sponsored/'
      preLoaderRoute: typeof AuthedOpsSponsoredIndexRouteImport
      parentRoute: typeof AuthedOpsRouteRoute
    }
    '/_authed/ops/sponsored/$id': {
      id: '/_authed/ops/sponsored/$id'
      path: '/sponsored/$id'
      fullPath: '/ops/sponsored/$id'
      preLoaderRoute: typeof AuthedOpsSponsoredIdRouteImport
      parentRoute: typeof AuthedOpsRouteRoute
    }
    '/_authed/ops/sponsored/new': {
      id: '/_authed/ops/sponsored/new'
      path: '/sponsored/new'
      fullPath: '/ops/sponsored/new'
      preLoaderRoute: typeof AuthedOpsSponsoredNewRouteImport
      parentRoute: typeof AuthedOpsRouteRoute
    }
    '/_authed/ops/surveys/': {
      id: '/_authed/ops/surveys/'
      path: '/surveys'
      fullPath: '/ops/surveys/'
      preLoaderRoute: typeof AuthedOpsSurveysIndexRouteImport
      parentRoute: typeof AuthedOpsRouteRoute
    }
    '/_authed/ops/surveys/$surveyId': {
      id: '/_authed/ops/surveys/$surveyId'
      path: '/surveys/$surveyId'
      fullPath: '/ops/surveys/$surveyId'
      preLoaderRoute: typeof AuthedOpsSurveysSurveyIdRouteImport
      parentRoute: typeof AuthedOpsRouteRoute
    }
    '/_authed/ops/surveys/new': {
      id: '/_authed/ops/surveys/new'
      path: '/surveys/new'
      fullPath: '/ops/surveys/new'
      preLoaderRoute: typeof AuthedOpsSurveysNewRouteImport
      parentRoute: typeof AuthedOpsRouteRoute
    }
    '/_authed/ops/transfer/': {
      id: '/_authed/ops/transfer/'
      path: '/transfer'
      fullPath: '/ops/transfer/'
      preLoaderRoute: typeof AuthedOpsTransferIndexRouteImport
      parentRoute: typeof AuthedOpsRouteRoute
    }
    '/_authed/org/$organizationId/': {
      id: '/_authed/org/$organizationId/'
      path: '/'
      fullPath: '/org/$organizationId/'
      preLoaderRoute: typeof AuthedOrgOrganizationIdIndexRouteImport
      parentRoute: typeof AuthedOrgOrganizationIdRouteRoute
    }
    '/_authed/org/$organizationId/members': {
      id: '/_authed/org/$organizationId/members'
      path: '/members'
      fullPath: '/org/$organizationId/members'
      preLoaderRoute: typeof AuthedOrgOrganizationIdMembersRouteImport
      parentRoute: typeof AuthedOrgOrganizationIdRouteRoute
    }
    '/_authed/org/$organizationId/settings': {
      id: '/_authed/org/$organizationId/settings'
      path: '/settings'
      fullPath: '/org/$organizationId/settings'
      preLoaderRoute: typeof AuthedOrgOrganizationIdSettingsRouteImport
      parentRoute: typeof AuthedOrgOrganizationIdRouteRoute
    }
    '/_authed/org/$organizationId/events/': {
      id: '/_authed/org/$organizationId/events/'
      path: '/events'
      fullPath: '/org/$organizationId/events/'
      preLoaderRoute: typeof AuthedOrgOrganizationIdEventsIndexRouteImport
      parentRoute: typeof AuthedOrgOrganizationIdRouteRoute
    }
    '/_authed/org/$organizationId/events/new': {
      id: '/_authed/org/$organizationId/events/new'
      path: '/events/new'
      fullPath: '/org/$organizationId/events/new'
      preLoaderRoute: typeof AuthedOrgOrganizationIdEventsNewRouteImport
      parentRoute: typeof AuthedOrgOrganizationIdRouteRoute
    }
    '/_authed/org/$organizationId/events/$eventId/': {
      id: '/_authed/org/$organizationId/events/$eventId/'
      path: '/events/$eventId'
      fullPath: '/org/$organizationId/events/$eventId/'
      preLoaderRoute: typeof AuthedOrgOrganizationIdEventsEventIdIndexRouteImport
      parentRoute: typeof AuthedOrgOrganizationIdRouteRoute
    }
    '/_authed/org/$organizationId/events/$eventId/edit': {
      id: '/_authed/org/$organizationId/events/$eventId/edit'
      path: '/events/$eventId/edit'
      fullPath: '/org/$organizationId/events/$eventId/edit'
      preLoaderRoute: typeof AuthedOrgOrganizationIdEventsEventIdEditRouteImport
      parentRoute: typeof AuthedOrgOrganizationIdRouteRoute
    }
    '/_authed/org/$organizationId/events/$eventId/runners': {
      id: '/_authed/org/$organizationId/events/$eventId/runners'
      path: '/events/$eventId/runners'
      fullPath: '/org/$organizationId/events/$eventId/runners'
      preLoaderRoute: typeof AuthedOrgOrganizationIdEventsEventIdRunnersRouteImport
      parentRoute: typeof AuthedOrgOrganizationIdRouteRoute
    }
  }
}

interface AuthedOpsRouteRouteChildren {
  AuthedOpsInboxRoute: typeof AuthedOpsInboxRoute
  AuthedOpsIndexRoute: typeof AuthedOpsIndexRoute
  AuthedOpsCandidatesCandidateIdRoute: typeof AuthedOpsCandidatesCandidateIdRoute
  AuthedOpsDuplicatesGroupIdRoute: typeof AuthedOpsDuplicatesGroupIdRoute
  AuthedOpsRulesRuleIdRoute: typeof AuthedOpsRulesRuleIdRoute
  AuthedOpsRulesNewRoute: typeof AuthedOpsRulesNewRoute
  AuthedOpsRunsRunIdRoute: typeof AuthedOpsRunsRunIdRoute
  AuthedOpsSourcesSourceIdRoute: typeof AuthedOpsSourcesSourceIdRoute
  AuthedOpsSponsoredIdRoute: typeof AuthedOpsSponsoredIdRoute
  AuthedOpsSponsoredNewRoute: typeof AuthedOpsSponsoredNewRoute
  AuthedOpsSurveysSurveyIdRoute: typeof AuthedOpsSurveysSurveyIdRoute
  AuthedOpsSurveysNewRoute: typeof AuthedOpsSurveysNewRoute
  AuthedOpsAuditIndexRoute: typeof AuthedOpsAuditIndexRoute
  AuthedOpsCandidatesIndexRoute: typeof AuthedOpsCandidatesIndexRoute
  AuthedOpsDuplicatesIndexRoute: typeof AuthedOpsDuplicatesIndexRoute
  AuthedOpsEventsIndexRoute: typeof AuthedOpsEventsIndexRoute
  AuthedOpsOrganizationsIndexRoute: typeof AuthedOpsOrganizationsIndexRoute
  AuthedOpsQualityIndexRoute: typeof AuthedOpsQualityIndexRoute
  AuthedOpsRulesIndexRoute: typeof AuthedOpsRulesIndexRoute
  AuthedOpsRunsIndexRoute: typeof AuthedOpsRunsIndexRoute
  AuthedOpsSourcesIndexRoute: typeof AuthedOpsSourcesIndexRoute
  AuthedOpsSponsoredIndexRoute: typeof AuthedOpsSponsoredIndexRoute
  AuthedOpsSurveysIndexRoute: typeof AuthedOpsSurveysIndexRoute
  AuthedOpsTransferIndexRoute: typeof AuthedOpsTransferIndexRoute
}

const AuthedOpsRouteRouteChildren: AuthedOpsRouteRouteChildren = {
  AuthedOpsInboxRoute: AuthedOpsInboxRoute,
  AuthedOpsIndexRoute: AuthedOpsIndexRoute,
  AuthedOpsCandidatesCandidateIdRoute: AuthedOpsCandidatesCandidateIdRoute,
  AuthedOpsDuplicatesGroupIdRoute: AuthedOpsDuplicatesGroupIdRoute,
  AuthedOpsRulesRuleIdRoute: AuthedOpsRulesRuleIdRoute,
  AuthedOpsRulesNewRoute: AuthedOpsRulesNewRoute,
  AuthedOpsRunsRunIdRoute: AuthedOpsRunsRunIdRoute,
  AuthedOpsSourcesSourceIdRoute: AuthedOpsSourcesSourceIdRoute,
  AuthedOpsSponsoredIdRoute: AuthedOpsSponsoredIdRoute,
  AuthedOpsSponsoredNewRoute: AuthedOpsSponsoredNewRoute,
  AuthedOpsSurveysSurveyIdRoute: AuthedOpsSurveysSurveyIdRoute,
  AuthedOpsSurveysNewRoute: AuthedOpsSurveysNewRoute,
  AuthedOpsAuditIndexRoute: AuthedOpsAuditIndexRoute,
  AuthedOpsCandidatesIndexRoute: AuthedOpsCandidatesIndexRoute,
  AuthedOpsDuplicatesIndexRoute: AuthedOpsDuplicatesIndexRoute,
  AuthedOpsEventsIndexRoute: AuthedOpsEventsIndexRoute,
  AuthedOpsOrganizationsIndexRoute: AuthedOpsOrganizationsIndexRoute,
  AuthedOpsQualityIndexRoute: AuthedOpsQualityIndexRoute,
  AuthedOpsRulesIndexRoute: AuthedOpsRulesIndexRoute,
  AuthedOpsRunsIndexRoute: AuthedOpsRunsIndexRoute,
  AuthedOpsSourcesIndexRoute: AuthedOpsSourcesIndexRoute,
  AuthedOpsSponsoredIndexRoute: AuthedOpsSponsoredIndexRoute,
  AuthedOpsSurveysIndexRoute: AuthedOpsSurveysIndexRoute,
  AuthedOpsTransferIndexRoute: AuthedOpsTransferIndexRoute,
}

const AuthedOpsRouteRouteWithChildren = AuthedOpsRouteRoute._addFileChildren(
  AuthedOpsRouteRouteChildren,
)

interface AuthedOrgOrganizationIdRouteRouteChildren {
  AuthedOrgOrganizationIdMembersRoute: typeof AuthedOrgOrganizationIdMembersRoute
  AuthedOrgOrganizationIdSettingsRoute: typeof AuthedOrgOrganizationIdSettingsRoute
  AuthedOrgOrganizationIdIndexRoute: typeof AuthedOrgOrganizationIdIndexRoute
  AuthedOrgOrganizationIdEventsNewRoute: typeof AuthedOrgOrganizationIdEventsNewRoute
  AuthedOrgOrganizationIdEventsIndexRoute: typeof AuthedOrgOrganizationIdEventsIndexRoute
  AuthedOrgOrganizationIdEventsEventIdEditRoute: typeof AuthedOrgOrganizationIdEventsEventIdEditRoute
  AuthedOrgOrganizationIdEventsEventIdRunnersRoute: typeof AuthedOrgOrganizationIdEventsEventIdRunnersRoute
  AuthedOrgOrganizationIdEventsEventIdIndexRoute: typeof AuthedOrgOrganizationIdEventsEventIdIndexRoute
}

const AuthedOrgOrganizationIdRouteRouteChildren: AuthedOrgOrganizationIdRouteRouteChildren =
  {
    AuthedOrgOrganizationIdMembersRoute: AuthedOrgOrganizationIdMembersRoute,
    AuthedOrgOrganizationIdSettingsRoute: AuthedOrgOrganizationIdSettingsRoute,
    AuthedOrgOrganizationIdIndexRoute: AuthedOrgOrganizationIdIndexRoute,
    AuthedOrgOrganizationIdEventsNewRoute:
      AuthedOrgOrganizationIdEventsNewRoute,
    AuthedOrgOrganizationIdEventsIndexRoute:
      AuthedOrgOrganizationIdEventsIndexRoute,
    AuthedOrgOrganizationIdEventsEventIdEditRoute:
      AuthedOrgOrganizationIdEventsEventIdEditRoute,
    AuthedOrgOrganizationIdEventsEventIdRunnersRoute:
      AuthedOrgOrganizationIdEventsEventIdRunnersRoute,
    AuthedOrgOrganizationIdEventsEventIdIndexRoute:
      AuthedOrgOrganizationIdEventsEventIdIndexRoute,
  }

const AuthedOrgOrganizationIdRouteRouteWithChildren =
  AuthedOrgOrganizationIdRouteRoute._addFileChildren(
    AuthedOrgOrganizationIdRouteRouteChildren,
  )

interface AuthedRouteChildren {
  AuthedOpsRouteRoute: typeof AuthedOpsRouteRouteWithChildren
  AuthedIndexRoute: typeof AuthedIndexRoute
  AuthedOrgOrganizationIdRouteRoute: typeof AuthedOrgOrganizationIdRouteRouteWithChildren
  AuthedOrgNewRoute: typeof AuthedOrgNewRoute
  AuthedOrgIndexRoute: typeof AuthedOrgIndexRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedOpsRouteRoute: AuthedOpsRouteRouteWithChildren,
  AuthedIndexRoute: AuthedIndexRoute,
  AuthedOrgOrganizationIdRouteRoute:
    AuthedOrgOrganizationIdRouteRouteWithChildren,
  AuthedOrgNewRoute: AuthedOrgNewRoute,
  AuthedOrgIndexRoute: AuthedOrgIndexRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthedRoute: AuthedRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignUpRoute: SignUpRoute,
  VerifyEmailRoute: VerifyEmailRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
